export const MAX_VALUE_RULE_NAME = "max_value";
/**
 * Validates that a number is not greater than a maximum value.
 */
export const Validator = {
    name: MAX_VALUE_RULE_NAME,
    errorMessage: `This field may not be greater than :${MAX_VALUE_RULE_NAME}.`,
    validate: (value, requirement) => Number(value) <= Number(requirement),
};
